import React from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

const MainContent = () => {
  return (
    <Container fluid className="main-content">
      <Outlet />
    </Container>
  );
};

export default MainContent;
